// screens/FavoritesScreen/hooks/useFavoritesScreen.ts (ВЕБ)
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectCurrentUser } from "../../store/slices/currentUserSlice";
import { selectCategoryList } from "../../store/slices/categoryListSlice";
import { selectHasUseStock } from "../../store/slices/saleItemListSlice";
import { selectFavoritesList } from "../../store/slices/favoritesSlice";
import { GroupedProduct } from "../../common/types/types";
import { ROUTES } from "../../common/utils/constants";
import { useSearch } from "../../common/hooks/useSearch";

export const useFavoritesScreen = () => {
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const categoryList = useSelector(selectCategoryList);
  const usingStock = useSelector(selectHasUseStock);
  const favorites = useSelector(selectFavoritesList);
  const isAuth = Boolean(currentUser?.id);

  // Удаленный поиск (локальный по favorites, без API)
  const {
    query,
    setQuery,
    filteredItems: searchResults,
    loading: searchLoading,
  } = useSearch(favorites);

  const getCategoryName = (id: number) => {
    return categoryList.find((el) => el.id === id)?.name || "";
  };

  const handleGroupPress = (group: GroupedProduct) => {
    navigate(`${ROUTES.GROUP}/${group.groupId}`);
  };

  const displayItems = searchResults.length > 0 ? searchResults : favorites;

  return {
    favorites: displayItems,
    getCategoryName,
    isAuth,
    usingStock,
    handleGroupPress,
    searchQuery: query,
    searchLoading,
    handleSearchChange: setQuery,
    handleSearchClear: () => setQuery(""),
  };
};
